
import styled from 'styled-components'

export const PropertyBusinessTypeWapper = styled.div`
    display: flex;
    svg {
        color: #ccc;
        font-size: 1.1em;
    }
    p{
        margin: 0;
        color: #444;
        font-weight: 300;
        margin-left: 5px;
        
    }
`